import { NavigationActions } from 'react-navigation';

export class NavigatorService {
  // TODO: Temporary till state can be shared between containers which is as of yet not possible in current infrastructure
  public static setTopLevelNavigatorContainerOne(navigator) {
    this.navigatorContainerOne = navigator;
  }

  public static setTopLevelNavigatorContainerTwo(navigator) {
    this.navigatorContainerTwo = navigator;
  }

  public static navigateContainerOne(routeName, params?) {
    if (!this.navigatorContainerOne) {
      return;
    }

    this.navigatorContainerOne.dispatch(
      NavigationActions.navigate({
        routeName,
        params,
      }),
    );
  }

  public static navigateContainerTwo(routeName, params?) {
    if (!this.navigatorContainerTwo) {
      return;
    }

    this.navigatorContainerTwo.dispatch(
      NavigationActions.navigate({
        routeName,
        params,
      }),
    );
  }

  private static navigatorContainerOne;
  private static navigatorContainerTwo;
}
